import React from "react";
import cx from "classnames";
import ReactPlayer from "react-player/vimeo";
import { ShadowBorder } from "src/components/shadow-border";

import * as styles from "./video-card.module.css";

export const VideoCard = ({
	title,
	url,
	className,
}: {
	title?: string;
	url: string;
	className?: string;
}) => {
	return (
		<div className={cx(styles.videoCard, className)}>
			<ShadowBorder>
				<div className={styles.inner}>
					{title && <h4 className={cx("label", styles.videoTitle)}>{title}</h4>}
					<div className={styles.videoContainer}>
						<ReactPlayer
							url={url}
							controls={true}
							width="100%"
							height="100%"
							style={{ position: `absolute` }}
						/>
					</div>
				</div>
			</ShadowBorder>
		</div>
	);
};
